import { useRef } from 'react'
import { Observer } from 'mobx-react-lite'
import times from 'lodash/times'
import { format } from 'date-fns/format'
import classNames from '@ui-components-3/ui/lib/utils/classNames'
import User from 'singletons/User'
import useMaxChildrenQuantity from 'hooks/useMaxChildrenQuantity'
import useStyles from './styles'
import VisitModalityIcon from 'components/Dashboard/cards/common/VisitModalityIcon'

const VisitsList = ({ visits, onRowClick, onSummaryRowClick, isMobile }) => {
  const classes = useStyles()
  const ref = useRef()
  const maxChilrenQuantity = useMaxChildrenQuantity(ref, !isMobile)

  const diff = visits.length - maxChilrenQuantity

  const visitsToShow = Math.min(diff + 1, visits.length)

  const mappedVisits = times(diff > 0 ? maxChilrenQuantity - 1 : visits.length, (i) => {
    return (
      <Observer key={i}>
        {() => (
          <div
            className={classNames(
              classes.visit,
              visits[i].scheduledAt === User.provider?.openedScheduledVisit.scheduledAt ? classes.openedVisit : '',
            )}
            onClick={(e) => onRowClick(e, visits[i])}
          >
            <VisitModalityIcon modality={visits[i].modality} />
            {format(new Date(visits[i].scheduledAt), 'hh:mm aaa')}
          </div>
        )}
      </Observer>
    )
  })
  if (diff > 0) {
    mappedVisits.push(
      <div className={classes.visit} key={maxChilrenQuantity} onClick={onSummaryRowClick}>
        +{visitsToShow} more visits
      </div>,
    )
  }
  return (
    <div className={classes.wrapper} ref={ref}>
      {mappedVisits}
    </div>
  )
}
export default VisitsList
